import { BaseQueryFn, EndpointBuilder } from "@reduxjs/toolkit/query";

export const adminTagTypes = [
    "Accounts",
    "AdminProducts",
    "AdminEvents",
    "AdminFiles",
    "AdminGroups",
    "AdminWorkspaces",
    "Certificate",
    "EmailConfig",
    "FdroidRepos",
    "LicenseStatistics",
    "OauthClients",
    "Roles",
    "Subscribers",
] as const;

type AdminTag = (typeof adminTagTypes)[number];

export type AdminBuilder = EndpointBuilder<BaseQueryFn, AdminTag, "adminApi">;
